(function () {

    // Track previously active index to correctly pause videos/iframes
    let prevMainIndex = 0;

    const buildVideoHandler = (listSelector) => {
        return {
            select: function (index) {
                const slides = document.querySelectorAll(listSelector + " .product__media-item");

                // Pause previous slide's media
                const prevSlide = slides[prevMainIndex];
                if (prevSlide) {
                    const prevVideo = prevSlide.querySelector("video");
                    if (prevVideo) prevVideo.pause();

                    const prevIframe = prevSlide.querySelector("iframe");
                    if (prevIframe) {
                        if (prevIframe.classList.contains("js-youtube")) {
                            prevIframe.contentWindow.postMessage(
                                JSON.stringify({ event: "command", func: "pauseVideo" }), "*"
                            );
                        } else {
                            prevIframe.contentWindow.postMessage('{"method":"pause"}', "*");
                        }
                    }
                }

                prevMainIndex = index;

                // Play current slide's media (deferred so Flickity finishes transition first)
                setTimeout(function () {
                    const currentSlide = slides[index];
                    if (!currentSlide) return;

                    const video = currentSlide.querySelector("video");
                    if (video) {
                        video.play();
                        return;
                    }

                    const iframe = currentSlide.querySelector("iframe");
                    if (iframe) {
                        if (iframe.classList.contains("js-youtube")) {
                            iframe.contentWindow.postMessage(
                                JSON.stringify({ event: "command", func: "playVideo" }), "*"
                            );
                        } else {
                            iframe.contentWindow.postMessage('{"method":"play"}', "*");
                        }
                    }
                }, 100);
            }
        };
    };

    const initProductAccordion = () => {
        $(document).off("click", ".product__additional");
        $(document).on("click", ".product__additional", function () {
            const $this = $(this);
            const $description = $this.find(".product__additional-description");

            if ($this.hasClass("active")) {
                $this.removeClass("active");
                $description.slideUp(300);
            } else {
                $(".product__additional.active").removeClass("active");
                $(".product__additional .product__additional-description").slideUp(300);
                $this.addClass("active");
                $description.slideDown(300);
            }
        });
    };

    const initCarousels = () => {
        // FIX 1: Guard against double-init — destroy existing instances first
        document.querySelectorAll(".product-section .product__media-list").forEach(function (elem) {
            if (elem.classList.contains("flickity-enabled")) {
                Flickity.data(elem).destroy();
            }
        });
        document.querySelectorAll(".product-section .product__media-sublist").forEach(function (elem) {
            if (elem.classList.contains("flickity-enabled")) {
                Flickity.data(elem).destroy();
            }
        });

        prevMainIndex = 0;

        // Init main sliders
        document.querySelectorAll(".product-section .product__media-list").forEach(function (elem) {
            var slider = new Flickity(elem, {
                pageDots: true,
                prevNextButtons: false,
                adaptiveHeight: true,
                wrapAround: true,
                on: buildVideoHandler(".product-section .product__media-list"),
            });

            const outer = elem.parentElement;
            const prevBtn = outer.querySelector(".product__media-list-wrapper-outer-arrow_prev");
            const nextBtn = outer.querySelector(".product__media-list-wrapper-outer-arrow_next");
            if (prevBtn) prevBtn.addEventListener("click", function () { slider.previous(); });
            if (nextBtn) nextBtn.addEventListener("click", function () { slider.next(); });
        });

        // FIX 2: pageDots: false on sublists — pageDots conflicts with asNavFor and fires duplicate events
        // FIX 3: draggable: false — prevents desync when user drags thumbnail rail
        document.querySelectorAll(".product-section .product__media-sublist").forEach(function (elem, index) {
            var cellCount = elem.querySelectorAll(".carousel-cell").length;
            var screenWidth = window.innerWidth;
            var showArrows = false;

            if (screenWidth > 1611) {
                showArrows = cellCount > 5;
            } else if (screenWidth > 1199) {
                showArrows = cellCount > 3;
            } else {
                showArrows = cellCount > 3;
            }

            new Flickity(elem, {
                asNavFor: document.querySelectorAll(".product-section .product__media-list")[index],
                contain: true,
                pageDots: false,       // FIX: was true — caused double nav events
                draggable: false,      // FIX: prevents thumbnail rail desync
                prevNextButtons: showArrows,
                cellAlign: "left",
            });
        });
    };

    document.addEventListener("shopify:section:load", function () {
        initCarousels();
        initProductAccordion();
        initModal("fancy-container-info");
    });

    $(document).ready(function () {
        if ($(".product-section").length > 0) {
            initCarousels();
        }
        initProductAccordion();
        initModal("fancy-container-info");
    });

})();




// (function () {

//     const initProductAccordion = () => {
//         $(document).off("click", ".product__additional");

//         $(document).on("click", ".product__additional", function () {
//             const $this = $(this);
//             const $description = $this.find(".product__additional-description");

//             if ($this.hasClass("active")) {
//                 $this.removeClass("active");
//                 $description.slideUp(300);
//             } else {
//                 $(".product__additional.active").removeClass("active");
//                 $(".product__additional .product__additional-description").slideUp(300);
//                 $this.addClass("active");
//                 $description.slideDown(300);
//             }
//         });
//     };

//     const initMainCarousels = (context) => {
//         document.querySelectorAll(".product-section .product__media-list").forEach(function (elem) {
//             // Force eager loading before Flickity init
//             elem.querySelectorAll("img").forEach(function (img) {
//                 img.setAttribute("loading", "eager");
//             });

//             var slider = new Flickity(elem, {
//                 pageDots: true,
//                 prevNextButtons: false,
//                 adaptiveHeight: true,
//                 wrapAround: true,
//                 imagesLoaded: true,
//                 on: {
//                     select: function (index) {
//                         let slides = $(".product-section .product__media-list .product__media-item");

//                         var iframe = $(slides[index]).find("iframe");
//                         var allIframes = document.querySelectorAll(".product-section .product__media-list iframe");
//                         var video = $(slides[index]).find("video");
//                         var allVideos = $(".product-section .product__media-list").find("video");

//                         if (video && video.length > 0) {
//                             video.get(0).play();
//                         } else if (allVideos && allVideos.length > 0) {
//                             allVideos.get(0).pause();
//                         }

//                         if (iframe && iframe.length > 0) {
//                             if (iframe[0].classList.contains("js-youtube")) {
//                                 iframe[0].contentWindow.postMessage(
//                                     JSON.stringify({ event: "command", func: "playVideo" }),
//                                     "*"
//                                 );
//                             } else {
//                                 iframe[0].contentWindow.postMessage('{"method":"play"}', "*");
//                             }
//                         } else if (allIframes && allIframes.length > 0) {
//                             allIframes.forEach(function (v) {
//                                 if (v.classList.contains("js-youtube")) {
//                                     v.contentWindow.postMessage(
//                                         JSON.stringify({ event: "command", func: "pauseVideo" }),
//                                         "*"
//                                     );
//                                 } else {
//                                     v.contentWindow.postMessage('{"method":"pause"}', "*");
//                                 }
//                             });
//                         } else {
//                             return false;
//                         }
//                     },
//                 },
//             });

//             // Store reference for sublist sync
//             elem._flickityInstance = slider;

//             var prevArrow = elem.parentElement.querySelector(".product__media-list-wrapper-outer-arrow_prev");
//             var nextArrow = elem.parentElement.querySelector(".product__media-list-wrapper-outer-arrow_next");

//             if (prevArrow) {
//                 prevArrow.addEventListener("click", function () {
//                     slider.previous();
//                 });
//             }
//             if (nextArrow) {
//                 nextArrow.addEventListener("click", function () {
//                     slider.next();
//                 });
//             }
//         });
//     };

//     const initSublistCarousels = () => {
//         document.querySelectorAll(".product-section .product__media-sublist").forEach(function (elem, index) {
//             var cellCount = elem.querySelectorAll(".carousel-cell").length;
//             var screenWidth = window.innerWidth;
//             var showArrows = false;

//             if (screenWidth > 1611) {
//                 showArrows = cellCount > 5;
//             } else if (screenWidth > 1199) {
//                 showArrows = cellCount > 3;
//             } else {
//                 showArrows = cellCount > 3;
//             }

//             var mainList = document.querySelectorAll(".product-section .product__media-list")[index];
//             var mainCellCount = mainList ? mainList.querySelectorAll(".carousel-cell").length : 0;

//             // Only use asNavFor if cell counts match — prevents skip bug
//             var useAsNavFor = (mainList && cellCount === mainCellCount) ? mainList : undefined;

//             var subSlider = new Flickity(elem, {
//                 asNavFor: useAsNavFor,
//                 contain: true,
//                 pageDots: false,
//                 prevNextButtons: showArrows,
//                 cellAlign: "left",
//                 imagesLoaded: true,
//             });

//             // Manual sync fallback when counts differ
//             if (!useAsNavFor && mainList && mainList._flickityInstance) {
//                 var mainFlkty = mainList._flickityInstance;

//                 mainFlkty.on("select", function () {
//                     subSlider.select(mainFlkty.selectedIndex, false, true);
//                 });

//                 subSlider.on("select", function () {
//                     mainFlkty.select(subSlider.selectedIndex, false, true);
//                 });
//             }
//         });
//     };

//     document.addEventListener("shopify:section:load", function () {
//         initMainCarousels();
//         initSublistCarousels();
//         initProductAccordion();
//         initModal("fancy-container-info");
//     });

//     $(document).ready(function () {
//         if ($(".product-section").length > 0) {
//             initMainCarousels();
//             initSublistCarousels();
//         }

//         initProductAccordion();
//         initModal("fancy-container-info");
//     });

// })();